import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import {
  useAddCompanyMutation,
  useDeleteCompanyMutation,
  useEditCompanyMutation
} from "../../../../redux/api/chemicalization/companyApi";
import { EntCompany } from "../../../../models/chemicalization/company";
import { getCookie } from "typescript-cookie";

const useCompany = (modal: any, refresh?: () => void) => {
  const { t } = useTranslation()
  const { confirm } = modal;
  const [addCompany] = useAddCompanyMutation();
  const [deleteCompany] = useDeleteCompanyMutation();
  const [editCompany] = useEditCompanyMutation();

  async function onAddCompany(newCompany: EntCompany): Promise<boolean> {
    try {
      let status: boolean = false;
      await addCompany(newCompany).then((response: any) => {
        if (response.error) {
          const isKyrgyz = getCookie('i18next') === 'ky';
          const lang = isKyrgyz ? 'kg' : 'ru';
          const res = response.error.data?.res;
          const errorMessages = Array.isArray(res)
            ? res.map((error: any) => error[lang] || error.ru).join('\n')
            : response.error.data?.msg || t('unknownError');
          throw new Error(errorMessages);
        }
        if (response.data.success) {
          status = true;
          message.success(t('msg.successAdd'));
          if (refresh) refresh();
        }
      }).catch((error: any) => {
        modal.error({ title: t('msg.error'), content: String(error.message) });

      });
      return status;
    } catch (error: any) {
      modal.error({ title: t('msg.error'), content: String(error.message) });
      return false;
    }
  }

  async function onDeleteCompany(company: EntCompany) {
    try {
      let status: boolean = false;
      confirm({
        centered: true,
        title: t('msg.confirmDeleteText'),
        okText: t('general.yes'),
        cancelText: t('general.no'),
        onOk() {
          deleteCompany(company.id as number).then((response: any) => {
            if (response.error) {
              const isKyrgyz = getCookie('i18next') === 'ky';
              const lang = isKyrgyz ? 'kg' : 'ru';
              const res = response.error.data?.res;
              const errorMessages = Array.isArray(res)
                  ? res.map((error: any) => error[lang] || error.ru).join('\n')
                  : response.error.data?.msg || t('unknownError'); 
              throw new Error(errorMessages);
          }
            if (response.data.success) {
              status = true;
              Modal.success({ title: t('msg.successDelete') });
              if (refresh) refresh();
            }
          }).catch((error: any) => {
            Modal.error({ title: t('msg.error'), content: String(error.message) });

          });
        }
      })
      return status
    } catch (error: any) {
      Modal.error({ title: t('msg.error'), content: String(error.message) });
      return false;
    }
  }

  async function onEditCompany(editedCompany: EntCompany): Promise<boolean> {
    try {
      let status: boolean = false;
      await editCompany(editedCompany).then((response: any) => {
        if (response.error) {
          const isKyrgyz = getCookie('i18next') === 'ky';
          const lang = isKyrgyz ? 'kg' : 'ru';
          const res = response.error.data?.res;
          const errorMessages = Array.isArray(res)
              ? res.map((error: any) => error[lang] || error.ru).join('\n')
              : response.error.data?.msg || t('unknownError'); 
          throw new Error(errorMessages);
      }
        if (response.data.success) {
          status = true;
          Modal.success({ title: t('msg.successEdited') });
          if (refresh) refresh();
        }
      }).catch((error: any) => {
        Modal.error({ title: t('msg.error'), content: String(error.message) });
      });
      return status;
    } catch (error: any) {
      Modal.error({ title: t('msg.error'), content: String(error.message) });
      return false;
    }
  }

  return { onAddCompany, onDeleteCompany, onEditCompany }
}

export { useCompany };

